const swap = (arr, left, right) => {
	const temp = arr[left]
	arr[left] = arr[right]
	arr[right] = temp;
}

const partitionHigh = (arr, low, high, animations) => {
	//Pick the first element as pivot
	let pivot = arr[high];
	let i = low;

	//Partition the array into two parts using the pivot
	for (let j = low; j < high; j++) {
		animations.push([j, high,true,true]);
		animations.push([j, high,false,true]);
		if (arr[j] <= pivot) {
			animations.push([[i, arr[j]],[j, arr[i]],false]);
			swap(arr, i, j);
			i++;
		}
	}
	animations.push([[i, arr[high]],[high, arr[i]],"out"]);
	swap(arr, i, high);

	//Return the pivot index
	return i;
}

export const iterativeQuickSort = (arr, animations) => {
	//Stack for storing start and end index
	let stack = [];

	//Get the start and end index
	let start = 0;
	let end = arr.length - 1;

	//Push start and end index in the stack
	stack.push({ x: start, y: end });

	//Iterate the stack
	while (stack.length) {
		//Get the start and end from the stack
		const { x, y } = stack.shift();

		//Partition the array along the pivot
		const PI = partitionHigh(arr, x, y, animations);

		//Push sub array with less elements than pivot into the stack
		if (PI - 1 > x) {
			stack.push({ x: x, y: PI - 1 });
		}

		//Push sub array with greater elements than pivot into the stack
		if (PI + 1 < y) {
			stack.push({ x: PI + 1, y: y });
		}
	}
}